import React, { useEffect, useState } from 'react';
import styles from './UserSettings.module.css';
import Usrnav from '../../usercomponents/Usrnav/Usrnav';
import axios from 'axios';
import config from '../../config/config';

const UserSettings = () => {
  const [formData, setFormData] = useState({
    username: '',
    contact: '',
    password: '',
    confirmPassword: '',
  });

  const [message, setMessage] = useState('');
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchUser = async () => {
      setIsLoading(true);
      try {
        const res = await axios.get(`${config.apiBaseUrl}/api/users/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setFormData({
          username: res.data.username || '',
          contact: res.data.contact || '',
          password: '',
          confirmPassword: ''
        });
      } catch (err) {
        setMessage('Failed to fetch user data');
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, [token]);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (showPasswordFields) {
      if (formData.password !== formData.confirmPassword) {
        setMessage("Passwords do not match");
        setIsLoading(false);
        return;
      }
      if (!formData.password) {
        setMessage("Password cannot be empty");
        setIsLoading(false);
        return;
      }
    }

    try {
      const dataToSend = {
        username: formData.username,
        contact: formData.contact,
      };

      if (showPasswordFields && formData.password) {
        dataToSend.password = formData.password;
      }

      const res = await axios.patch(`${config.apiBaseUrl}/api/users/update`, dataToSend, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setMessage(res.data.message || 'Updated successfully');

      if (showPasswordFields) {
        setShowPasswordFields(false);
        setFormData(prev => ({
          ...prev,
          password: '',
          confirmPassword: ''
        }));
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Update failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
         <div className="nav-wrapper">
                <Usrnav />
              </div>
      <div className={styles.card}>
        <h2 className={styles.title}>User Settings</h2>
        <div className={styles.avatarContainer}>
          <div className={styles.avatar}>
            {formData.username.charAt(0).toUpperCase()}
          </div>
          <h3 className={styles.username}>{formData.username}</h3>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGroup}>
            <label className={styles.label}>Change Username</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className={styles.input}
              placeholder="Enter your username"
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}> Change Phone Number</label>
            <input
              type="text"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
              className={styles.input}
              placeholder="Enter your phone number"
            />
          </div>

          {!showPasswordFields ? (
            <button
              type="button"
              onClick={() => {
                setShowPasswordFields(true);
                setMessage('');
              }}
              className={styles.changePasswordButton}
            >
              <i className={`${styles.icon} fas fa-lock`}></i>
              Change Password
            </button>
          ) : (
            <div className={styles.passwordSection}>
              <div className={styles.formGroup}>
                <label className={styles.label}>New Password</label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className={styles.input}
                  placeholder="Enter new password"
                />
              </div>

              <div className={styles.formGroup}>
                <label className={styles.label}>Confirm New Password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className={styles.input}
                  placeholder="Confirm new password"
                />
              </div>
            </div>
          )}

          <button 
            type="submit" 
            className={styles.submitButton}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className={`${styles.spinner} fas fa-spinner fa-spin`}></i>
                Saving...
              </>
            ) : (
              'Save Changes'
            )}
          </button>

          {message && (
            <div className={`${styles.message} ${message.includes('success') ? styles.success : styles.error}`}>
              {message}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default UserSettings;